"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _uniqBy2 = _interopRequireDefault(require("lodash/uniqBy"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down5"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right5"));
var _question = _interopRequireDefault(require("cccisd-icons/question4"));
var _cccisdToggle = _interopRequireDefault(require("cccisd-toggle"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var SessionSettings = function SessionSettings(_ref) {
  var deployment = _ref.deployment,
    displaySettings = _ref.displaySettings,
    isHideDcwDropdown = _ref.isHideDcwDropdown,
    session = _ref.session,
    setSettings = _ref.setSettings,
    settings = _ref.settings;
  var disableSurveyOverride = displaySettings.disableSurveyOverride,
    enableAllowRetakeToggle = displaySettings.enableAllowRetakeToggle,
    enableMustTakeInOrderToggle = displaySettings.enableMustTakeInOrderToggle,
    toggleForRequired = displaySettings.toggleForRequired;

  // These are used to distinguish between initial load and a deleted session
  var isInitialMount = (0, _react.useRef)(true);
  var prevSession = (0, _react.useRef)(session);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    hadSessionChange = _useState2[0],
    setHadSessionChange = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isOptionsExpanded = _useState4[0],
    setIsOptionsExpanded = _useState4[1];
  var initialSettings = {
    options: (0, _get2["default"])(deployment, 'settings.options', []),
    toggleForRequired: toggleForRequired === true
  };
  if (enableAllowRetakeToggle) {
    initialSettings.allowRetake = (0, _get2["default"])(deployment, 'settings.allowRetake', false);
  }
  if (enableMustTakeInOrderToggle) {
    // mustTakeInOrder is a setting on the Quest, not DCW. In the case of
    // courseWrapper, it is in a slightly different location (assumes
    // course).
    var selectedNav = (0, _get2["default"])(deployment, 'assignment.settings.navigation', '');
    var defaultMustTakeInOrderPath = "assignment.settings.navigationSettings.".concat(selectedNav.startsWith('courseWrapper') ? 'course.' : '', "mustTakeInOrder");
    var defaultMustTakeInOrder = (0, _get2["default"])(deployment, defaultMustTakeInOrderPath, true);
    initialSettings.mustTakeInOrder = (0, _get2["default"])(deployment, 'mustTakeInOrder', defaultMustTakeInOrder);
  }
  var _useReducer = (0, _react.useReducer)(reducer, Object.assign(initialSettings, settings)),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    settingsState = _useReducer2[0],
    dispatch = _useReducer2[1];
  var allowRetake = settingsState.allowRetake,
    mustTakeInOrder = settingsState.mustTakeInOrder,
    options = settingsState.options;
  function reducer(state, _ref2) {
    var field = _ref2.field,
      value = _ref2.value,
      replaceState = _ref2.replaceState;
    if (replaceState) {
      return replaceState;
    }
    var newState = _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, field, value));
    return newState;
  }

  /* /////////////////////////////////////////////////////////////////////////
  // LIFECYCLE-RELATED //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  (0, _react.useEffect)(function () {
    // Default to deployment's settings when deployment changes
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else if (prevSession.current === session && !hadSessionChange) {
      var overrideSettings = {
        options: (0, _get2["default"])(deployment, 'settings.options', [])
      };
      if (enableAllowRetakeToggle) {
        overrideSettings.allowRetake = (0, _get2["default"])(deployment, 'settings.allowRetake', false);
      }
      if (enableMustTakeInOrderToggle) {
        // mustTakeInOrder is a setting on the Quest, not DCW. In the
        // case of courseWrapper, it is in a slightly different
        // location (assumes course).
        var _selectedNav = (0, _get2["default"])(deployment, 'assignment.settings.navigation', '');
        var _defaultMustTakeInOrderPath = "assignment.settings.navigationSettings.".concat(_selectedNav.startsWith('courseWrapper') ? 'course.' : '', "mustTakeInOrder");
        overrideSettings.mustTakeInOrder = (0, _get2["default"])(deployment, _defaultMustTakeInOrderPath, true);
      }
      setSettings(Object.assign(settings, overrideSettings));
    }

    // Use the existing session's settings if the session changes
    if (prevSession.current !== session) {
      dispatch({
        replaceState: session.settings
      });
      prevSession.current = session;
      setHadSessionChange(true);
    } else {
      setHadSessionChange(false);
    }
  }, [deployment, session]);
  (0, _react.useEffect)(function () {
    // Because setSettings is in a different component, we must call it
    // like this to avoid re-rendering during a state update
    setSettings(settingsState);
  }, [settingsState]);

  /* /////////////////////////////////////////////////////////////////////////
  // GENERAL FUNCTIONS //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  /**
   * Determine what the new options should be and set them.
   * @param {Event}  e The triggering event
   * @param {object} s The survey object (from graphql)
   */
  function onOptionsChange(e, s) {
    var updatedOptions = _toConsumableArray(options);
    var value = e.target.value;
    if (value === 'true' && options.includes(s.surveyHandle)) {
      updatedOptions = options.filter(function (o) {
        return o !== s.surveyHandle;
      });
    }
    if (value === 'false' && !options.includes(s.surveyHandle)) {
      updatedOptions = [].concat(_toConsumableArray(options), [s.surveyHandle]);
    }
    onSettingsChange({
      target: {
        name: 'options',
        value: updatedOptions
      }
    });
  }
  function onSettingsChange(e) {
    dispatch({
      field: e.target.name,
      value: e.target.value
    });
  }

  /* /////////////////////////////////////////////////////////////////////////
  // RENDER-RELATED /////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  var renderAllowRetake = !enableAllowRetakeToggle ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].formField
  }, /*#__PURE__*/_react["default"].createElement("input", {
    checked: allowRetake,
    name: "allowRetake",
    onChange: function onChange() {
      return onSettingsChange({
        target: {
          name: 'allowRetake',
          value: !allowRetake
        }
      });
    },
    type: "checkbox"
  }), "\xA0\xA0", /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "allowRetake"
  }, "Allow respondents to edit their answers after submitting?"));
  var renderMustTakeInOrder = !enableMustTakeInOrderToggle ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].formField
  }, /*#__PURE__*/_react["default"].createElement("input", {
    checked: mustTakeInOrder,
    name: "mustTakeInOrder",
    onChange: function onChange() {
      return onSettingsChange({
        target: {
          name: 'mustTakeInOrder',
          value: !mustTakeInOrder
        }
      });
    },
    type: "checkbox"
  }), "\xA0\xA0", /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
    title: "This setting may not apply to the selected Data Collection Wave"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "mustTakeInOrder"
  }, "Must Take in Order")));
  var renderOptions = function renderOptions() {
    var _deployment$assignmen;
    if (disableSurveyOverride) {
      return null;
    }
    var uniqueSurveys = (0, _uniqBy2["default"])((deployment === null || deployment === void 0 ? void 0 : (_deployment$assignmen = deployment.assignment) === null || _deployment$assignmen === void 0 ? void 0 : _deployment$assignmen.surveyList) || [], 'surveyHandle');

    /* `filter` so it doesn't count any archived or deleted surveys that
     * are still saved in session settings
     * `try-catch` becuase this will fail if no deployment is selected yet
     */
    var totalOptions;
    var selectedOptions;
    try {
      totalOptions = uniqueSurveys.length;
      selectedOptions = session.settings.options.filter(function (opt) {
        return uniqueSurveys.some(function (s) {
          return s.surveyHandle === opt;
        });
      }).length;
    } catch (e) {
      totalOptions = 0;
      selectedOptions = 0;
    }
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        marginTop: enableAllowRetakeToggle || enableMustTakeInOrderToggle ? '-8px' : null
      }
    }, /*#__PURE__*/_react["default"].createElement("button", {
      className: 'btn btn-link ' + _style["default"].surveyListCollapse,
      type: "button",
      onClick: function onClick() {
        return setIsOptionsExpanded(function (prev) {
          return !prev;
        });
      },
      disabled: !totalOptions
    }, isOptionsExpanded ? /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null) : /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], null), "\xA0", toggleForRequired && 'Required ', "Survey List", ' ', !isOptionsExpanded && "(".concat(selectedOptions, " of ").concat(totalOptions, " selected)")), /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: "Which surveys do you want ".concat(toggleForRequired === true ? 'to be REQUIRED' : 'ON', " for this assignment plan?"),
      placement: "right"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].helpTooltip
    }, /*#__PURE__*/_react["default"].createElement(_question["default"], null)))), isOptionsExpanded && uniqueSurveys.map(function (s, i) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: i,
        className: _style["default"].formField
      }, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
        label: s.label,
        name: s.surveyHandle,
        onChange: function onChange(e) {
          return onOptionsChange(e, s);
        },
        value: !!options.find(function (o) {
          return o === s.surveyHandle;
        })
      }));
    }));
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, renderAllowRetake, renderMustTakeInOrder, renderOptions());
};
SessionSettings.propTypes = {
  changeField: _propTypes["default"].func,
  deployment: _propTypes["default"].object,
  displaySettings: _propTypes["default"].object,
  session: _propTypes["default"].object,
  setSettings: _propTypes["default"].func,
  settings: _propTypes["default"].object
};
var _default = exports["default"] = SessionSettings;